import { memo, useMemo } from 'react';
import { withObservability } from '../components/Decorators';
import WarningComponent from '../components/WarningComponent';
import { PageDataModel } from '../strapi/types';
import ComponentsMap from './componentsMap';

const STICKY_BAR = 'StickyBar';

const getObservedComponents = (pageData?: PageDataModel): Set<number> => {
  if (!pageData) return new Set();

  const stickyBar = pageData.components?.find(({ component }) => component === STICKY_BAR);

  if (!stickyBar) {
    return new Set();
  }

  const hideStickyBarOn = stickyBar.content?.hideStickyBarOn?.replace(/\s/g, '').split(',') || [];
  const indexesToHide = hideStickyBarOn.map(Number).filter(n => !Number.isNaN(n));

  return new Set(indexesToHide);
};

const LandingComponents = ({ pageData }: { pageData: PageDataModel }) => {
  const observedComponents = useMemo(
    () => getObservedComponents(pageData),
    [pageData?.components?.length],
  );

  const Components = useMemo(() => {
    return pageData?.components?.map(({ component, content }, index) => {
      const Component = ComponentsMap[component];
      const ComponentWithObservability =
        Component && observedComponents.has(index + 1)
          ? withObservability(Component)
          : Component || null;
      // Code below fix LazyComponent re-rendering(flickering) and Total Blocking Time, which will give us minify JS better value
      return ComponentWithObservability ? (
        <ComponentWithObservability
          key={`${component}${index.toString()}`}
          {...{ slug: pageData.slug, ...content }}
          index={index + 1}
        />
      ) : (
        <WarningComponent
          key={`${component}${index.toString()}_warning`}
          componentName={component}
        />
      );
    });
  }, [observedComponents, pageData?.components?.length, pageData?.slug]);

  return Components;
};

export default memo(LandingComponents);
